var map = {
	"./Co-Funded-EU_POS.png": 9033,
	"./EMV-LII_logo.png": 6783,
	"./Emvi_logo_OK.png": 7144,
	"./IGO_Logo.png": 7401,
	"./Teilen_ICON.svg": 1182,
	"./cc-by-sa.svg": 4512,
	"./decidim-logo-mobile.svg": 5733,
	"./mitgestalten-logo.png": 295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1027;